import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }

import { computed } from 'vue';
import { useStore } from 'vuex';
import Endpoints from '@shell/components/formatter/Endpoints.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useFetch } from '@shell/components/Resource/Detail/FetchLoader/composables';

/**
 * Shows the endpoints of a workload in its popover card: the public endpoints the same way as the Endpoints column of
 * workload lists, then the Gateway API endpoints with the links the workload detail page shows.
 *
 * What the Gateway API endpoints are worked out from is fetched when this is shown, because it often isn't in the store.
 * Avoid it in lists, where every row would fetch it
 */
export interface Props {
  /**
   * The publicEndpoints annotation of the workload
   */
  value?: string;
  /**
   * The workload
   */
  row: any;
  col?: object;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkloadGlanceEndpoints',
  props: {
    value: { default: undefined },
    row: {},
    col: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);
const fetch = useFetch(async() => await props.row.fetchGatewayEndpointResources?.());

const hasPublicEndpoints = computed(() => !!props.row.publicEndpoints?.length);
const gatewayEndpoints = computed<{ link: string, linkDisplay: string }[]>(() => (fetch.value.loading ? [] : props.row.glanceGatewayEndpoints || []));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (hasPublicEndpoints.value)
      ? (_openBlock(), _createBlock(Endpoints, {
          key: 0,
          value: props.value,
          row: props.row,
          col: props.col
        }, null, 8, ["value", "row", "col"]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (_unref(fetch).loading)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: "icon icon-spinner icon-spin",
          role: "status",
          "aria-label": _unref(i18n).t('component.resource.detail.glance.ariaLabel.loading')
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gatewayEndpoints.value, (endpoint) => {
            return (_openBlock(), _createElementBlock("a", {
              key: endpoint.link,
              class: "block gateway-endpoint",
              href: endpoint.link,
              target: "_blank",
              rel: "nofollow noopener noreferrer"
            }, _toDisplayString(endpoint.linkDisplay), 9, _hoisted_2))
          }), 128)),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (!hasPublicEndpoints.value && !gatewayEndpoints.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "—"))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})